import { useEffect } from 'react';

import { Flex, useMaxWidth } from '@grupoboticario/flora-react';
import { ExclamationMarkHexagonIcon } from '@grupoboticario/flora-react-icons';
import config from 'config';
import { user } from 'core';
import { useCartShippingModelNotFound } from 'core/use-cases/cart/selectors';
import { getWhatsAppLink } from 'core/utilities';
import { Link, useNavigate } from 'react-router';
import {
  ButtonSolid,
  ButtonGhost,
  Container,
  Layout,
  Text,
  ResponsiveFloraTypography,
} from 'ui/components/primitives';
import { theme } from 'ui/theme';

import useHandleClick from './useHandleClick';

export const Error403 = () => {
  const navigate = useNavigate();
  const { handleTrackClick } = useHandleClick();
  const isMobile = useMaxWidth('992px');

  const {
    data: { isBlocked: isUserBlocked },
  } = user.hooks.useUser();
  const homePath = '/departamentos';
  const shippingModelNotFound = useCartShippingModelNotFound();

  useEffect(() => {
    if (!isUserBlocked && !shippingModelNotFound) {
      navigate(homePath);
    }
  }, [homePath, shippingModelNotFound]);

  return (
    <>
      <Layout horizontalAlign="left" data-testid="error-403">
        <Container marginBottom="sp-18" marginTop="sp-18">
          <Flex justify="center">
            <ExclamationMarkHexagonIcon
              css={{ color: theme.colors.action.nonInteractive.emphasis }}
              size="64"
            />
          </Flex>
        </Container>
      </Layout>
      <Layout>
        <Container marginBottom="sp-0" marginTop="sp-0">
          <ResponsiveFloraTypography
            as="h1"
            fontSize="subtitle"
            color={`${theme.colors.action.nonInteractive.emphasis}`}
            css={{
              textAlign: 'center',
              margin: 0,
            }}
          >
            A sua conta está bloqueada ou desativada
          </ResponsiveFloraTypography>
        </Container>
      </Layout>
      <Layout>
        <Container marginTop="sp-6" marginBottom="sp-2" size="2/3">
          <Text color="medium-light-1" textAlign="center" variant="body-large-standard">
            Para mais informações, entre em contato conosco. Atendimento de segunda a sexta das 9h
            às 18h e sábado das 9h às 16h (horário de Brasília)
          </Text>
        </Container>
      </Layout>
      <Layout>
        <Container marginTop="sp-0" marginBottom="sp-2" size="2/3">
          <Text color="medium-light-1" textAlign="center" variant="body-large-standard">
            WhatsApp: {config.communication.sac.whatsapp}
          </Text>
        </Container>
      </Layout>
      <Layout>
        <Container marginTop="sp-0" marginBottom="sp-2" size="2/3">
          <Text color="medium-light-1" textAlign="center" variant="body-large-standard">
            Telefone: {config.communication.sac.phone}
          </Text>
        </Container>
      </Layout>
      <Layout>
        <Container marginTop="sp-0" marginBottom="sp-6" size="2/3">
          <Text color="medium-light-1" textAlign="center" variant="auxiliar-small">
            Ligação gratuita de qualquer lugar do país tanto de telefone fixo quanto de celulares
          </Text>
        </Container>
      </Layout>
      <Layout data-testid="error" verticalAlign="center">
        <Container marginBottom="sp-0" marginTop="sp-6" size="2/3">
          <Link
            to={getWhatsAppLink(config.communication.sac.whatsapp, isMobile)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleTrackClick}
          >
            <ButtonSolid stretch>Acessar o Whatsapp</ButtonSolid>
          </Link>
        </Container>
      </Layout>
      <Layout data-testid="error" verticalAlign="center">
        <Container marginBottom="sp-6" marginTop="sp-6" size="2/3">
          <Link to="/pedidos?tab=a-pagar" target="_self" onClick={handleTrackClick}>
            <ButtonGhost stretch>Conferir boletos e pedidos</ButtonGhost>
          </Link>
        </Container>
      </Layout>
    </>
  );
};

export default Error403;
